import { createLazyComponent } from '@luna/utils-ui';

export const LazyDevToolsConfigEditor = createLazyComponent(() =>
    import('./DevToolsConfigEditor' /* webpackChunkName: "DevToolsConfigEditor" */).then(
        ({ DevToolsConfigEditor }) => DevToolsConfigEditor,
    ),
);
